import React from 'react';

export const FormatHeader = props => {
  const { breadcrumbText, textDecoration = true } = props;
  const [first, ...rest] = breadcrumbText ? breadcrumbText.split(' ') : '';
  return breadcrumbText !== 'TotalEnvironment' ? (
    <p className={textDecoration ? 'decorate' : 'remove-decoration'}>
      <b>{first}</b> {rest.join(' ')}
    </p>
  ) : (
    <p className={textDecoration ? 'decorate' : 'remove-decoration'}>
      <b>Total</b>Environment
    </p>
  );
};
